<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step4_shade.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step4_shade.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">
          <form-shade v-for="shade, index in form" :key="index" v-bind:form="shade" v-bind:index="index" v-bind:shades="form"></form-shade>
          <div class="actions">
            <button type="button" @click="onAddShade" class="button-add">
              <i class="ic ic-add"></i>
              {{ Translator('soprasolar.project.step4_shade.collection.add') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .project-wrapper {
    @include vertical-spacing-inner-top;
  }
  .actions {
    text-align: center;
  }
  .button-add {
    @include cta($color-main, $white);
    border: rem(1) solid $color-main;
    .ic {
      margin-right: rem(5);
      font-size: rem(26);
    }
  }
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';
import FormShade from '@/soprasolar-project/components/Form-shade';
import Save from '@/soprasolar-project/components/Save';

export default {
  name: 'step-4-shade',
  components: {
    FormShade,
    Save
  },
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: []
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step4) this.form = this.datas.step4;
    else this.onAddShade();
  },
  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        AppControlService.update('step4', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    onAddShade() {
      this.form.push({});
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step4) this.form = this.datas.step4;
    }
  }
};
</script>